<template>
	<div class="official-recommend-page">
		<div class="content-container">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<router-link to="/" class="breadcrumb-item">首页</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">猜你喜欢</span>
			</div>
			<div class="officialList">
				<OfficalItem class="officalItem" :data="item" v-for="(item,index) in userLike" :key="index">
				</OfficalItem>
			</div>

			<!-- 分页控件 -->
			<PagePagination :currentPage="currentPage" :total="total" @current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	import OfficalItem from '../components/OfficalItem.vue'
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'GuessLike',
		components: {
			OfficalItem,
			PagePagination
		},
		data() {
			return {
				userLike: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.getUserLike()
			},
			getUserLike() {
				this.$api.post('/Hua/user_like', {
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.userLike = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
		},
		mounted() {
			this.getUserLike()
		}
	}
</script>

<style scoped lang="scss">
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	@media (max-width: 480px) {
		.officialList {
			width: 12rem;
			display: flex;
			flex-wrap: wrap;

			.officalItem:nth-child(2n) {
				margin-right: 0;
			}
		}
	}

	@media (min-width: 481px) {
		.officialList {
			width: 12rem;
			display: flex;
			flex-wrap: wrap;

			.officalItem:nth-child(4n) {
				margin-right: 0;
			}
		}
	}
</style>